import { render, staticRenderFns } from "./clinicDrugsManagementTable.vue?vue&type=template&id=3cadb944&scoped=true"
import script from "./clinicDrugsManagementTable.vue?vue&type=script&lang=js"
export * from "./clinicDrugsManagementTable.vue?vue&type=script&lang=js"
import style0 from "./clinicDrugsManagementTable.vue?vue&type=style&index=0&id=3cadb944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cadb944",
  null
  
)

export default component.exports